<template>
  <v-container>
    <v-layout>
      <v-container>
        <v-layout row wrap>
          <v-flex ma-1 class="expandableContainer">
            <v-data-table
              :class="'tabledata'"
              hide-actions
              :loading="loading"
              :items="datails"
              :height="'14vh'"
            >
              <template v-slot:headers>
                <tr>
                  <th>{{ $t('surveys.question') }}</th>
                  <th>{{ $t('surveys.answers') }}</th>
                  <th style="max-width: 100px; min-width: 100px; width: 100px">
                    {{ $t('surveys.alert') }}
                  </th>
                  <th>
                    {{ $t('surveys.answered_by') }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td>{{ props.item.question }}</td>
                <td>{{ props.item.answer }}</td>
                <td
                  class="text-xs-center"
                  style="max-width: 100px; min-width: 100px; width: 100px"
                >
                  <div class="text-xs-center" style="margin-left: 15px">
                    <v-img
                      :src="getIconAlert(props.item.alert)"
                      width="22px"
                      class="text-xs-center"
                    ></v-img>
                  </div>
                </td>
                <td>{{ parent.name }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <loading v-model="working.wLoading" text="Trabajando"></loading>
        <success v-model="toast.success" text="Operación Exitosa"></success>
        <error v-model="toast.failed" text="Ups ocurrió un error"></error>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
export default {
  components: {
    loading,
    success,
    error,
  },
  props: ['datails', 'parent'],
  data: () => ({
    headers: [
      {
        text: 'Nombre',
        align: 'left',
        value: 'parentName',
      },
      {
        text: 'Apellido',
        value: 'lastName',
      },
      {
        text: 'Usuario',
        value: 'typeUser',
      },
      {
        text: 'Puerta',
        value: 'door',
      },
      {
        text: 'Transporte',
        value: 'carModel',
      },
      {
        text: 'Modelo',
        value: 'carModel',
      },
      {
        text: 'Color',
        value: 'carColor',
      },
      {
        text: 'Placas',
        value: 'plates',
      },
    ],
    selected: [],
    select: {
      parent: null,
    },
    working: {
      wLoading: false,
    },
    loading: false,
    tile: false,
    modals: {
      title: '',
      parent: false,
      import: false,
      value: false,
      LinkV: false,
    },
    buttonFab: {
      fab: false,
      hidden: false,
    },
    gotImages: 0,
    toast: {
      success: false,
      failed: false,
    },
  }),
  created() {},
  mounted() {},
  methods: {
    getIconAlert(item) {
      if (item == true) {
        return require('@/assets/polls/icons/alertaC.png')
      }
    },
  },
}
</script>

<style scoped>
.no-padding {
  padding-left: 8%;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}

.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}

th,
td {
  width: 300px;
  max-width: 300px;
  min-width: 300px;
}

/deep/ .v-datatable.v-table > tbody {
  max-height: 9vh;
  min-height: 9vh;
}
</style>
